import { useState } from 'react';
import LegalModal from './LegalModal';
import TermsContent from './legal/TermsContent';
import PrivacyContent from './legal/PrivacyContent';

export default function Footer() {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <>
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="text-center sm:text-left">
              <p className="text-sm text-gray-500">
                © {new Date().getFullYear()} CTE Course Platform. All rights reserved.
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Powered by{' '}
                <a 
                  href="https://www.cteconsultants.net" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-indigo-600 hover:text-indigo-700 font-medium"
                >
                  CTE Consultants & General Sales LLC
                </a>
              </p>
            </div>
            <div className="flex space-x-6">
              <button
                onClick={() => setTermsOpen(true)}
                className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
              >
                Terms of Service
              </button>
              <button
                onClick={() => setPrivacyOpen(true)}
                className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <LegalModal 
        isOpen={termsOpen} 
        onClose={() => setTermsOpen(false)}
        title="Terms of Service"
      >
        <TermsContent />
      </LegalModal>

      <LegalModal 
        isOpen={privacyOpen} 
        onClose={() => setPrivacyOpen(false)}
        title="Privacy Policy"
      >
        <PrivacyContent />
      </LegalModal>
    </>
  );
}
